<template>
    <div>
        <div id="main" v-show="!rotaAninhada">
            <container-loader
                v-if="isLoading && !$store.getters.isLoading"
            />
            <div class="page">
                <div class="vertical-flow">
                    <div class="listing-header">
                        <!-- TÍTULO E BREADCRUMB -->
                        <div class="title-breadcrumb">
                            <h1 class="title">{{ $t("routes") }}</h1>
                            <nav class="breadcrumb" aria-label="breadcrumbs">
                                <ul>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("vendas")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a class="a-inativo">{{
                                            $t("cadastros")
                                        }}</a>
                                    </li>
                                    <li>
                                        <a aria-current="page">{{
                                            $t("routes")
                                        }}</a>
                                    </li>
                                </ul>
                            </nav>
                        </div>

                        <!-- BOTÕES -->
                        <div class="header-buttons" v-if="permissao.create && !rotaIntegracao">
                            <router-link
                                class="save-btn"
                                type="button"
                                tag="button"
                                :to="{ name: 'vendas-new-rotavisita' }"
                            >
                                {{ $t("adicionar") }}
                            </router-link>
                        </div>
                    </div>

                    <!-- PESQUISA E FILTROS -->
                    <div class="columns is-multiline">
                        <div class="column is-three-quarters">
                            <search-bar
                                :onSearch="debouncedOnSearch"
                            />
                        </div>

                        <!-- SITUACAO -->
                        <div class="situacao-select column is-one-quarter">
                            <label v-text="$t('situacao')" />
                            <v-select
                                ref="situacaoInput"
                                class="is-100"
                                label="label"
                                :options="situacoes"
                                @input="updateSituacao"
                                v-model="situacao"
                            >
                                <template slot="option" slot-scope="option">
                                    {{ $t(option.label) }}
                                </template>
                                <template
                                    slot="selected-option"
                                    slot-scope="option"
                                >
                                    {{ $t(option.label) }}
                                </template>
                                <template slot="no-options">{{
                                    $t("sem-resultados")
                                }}</template>
                            </v-select>
                        </div>
                    </div>

                    <!-- LISTAGEM -->
                    <div class="rotasvisita-table registry-wrapper">
                        <empty-table-message v-if="isEmpty" />
                        <b-table
                            v-else
                            class="data-table"
                            :data="allrotas"
                            @sort="sortTable"
                            backend-sorting
                            height="calc(100vh - 270px)"
                            sticky-header
                        >
                            <b-table-column
                                v-for="(f, i) in fields"
                                class="td-center"
                                :key="i"
                                :field="f.key"
                                :label="f.key"
                                :width="f.width"
                                :sortable="f.sortable"
                                v-slot="props"
                            >
                                <div v-if="f.key == 'descricao'">
                                    <router-link
                                        :to="{
                                            name: 'vendas-edit-rotavisita',
                                            params: { id: props.row.id },
                                        }"
                                    >
                                        <pre>{{ props.row[f.key] }}</pre>
                                    </router-link>
                                </div>
                                <div v-else-if="f.key == 'usuario'">
                                    {{
                                        props.row.usuario
                                            ? props.row.usuario.nome
                                            : ""
                                    }}
                                </div>
                                <div v-else-if="f.key == 'situacao'">
                                    <ButtonUpdateStatus 
                                        :service="service"
                                        :record="'rota'"
                                        :item="props.row"
                                        :identifier="props.row.descricao"
                                        :canDelete="permissao.delete"
                                        :rotaIntegracao="rotaIntegracao"
                                        @loadData="carregarDados(pagination.currentPage)"
                                    />
                                </div>
                                <div v-else>
                                    {{ props.row[f.key] }}
                                </div>
                            </b-table-column>
                        </b-table>
                        <PaginationViewer
                            class="mb-0"
                            :resetPagination="pagination.resetPagination"
                            :totalItems="pagination.totalRows"
                            :perPageOptions="pagination.perPageOptions"
                            :optionStarted="pagination.optionStarted"
                            @change="updatePagination"
                        />
                    </div>
                </div>
            </div>
        </div>
        <router-view />
    </div>
</template>

<script>
import RotaVisitaService from "@/services/RotaVisitaService";
import ContainerLoader from "@/components/content/loader/ContainerLoader";
import ButtonUpdateStatus from '@/components/shared/buttons/ButtonUpdateStatus.vue';

export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name.includes("rotavisita") && to.name != "ven-rotavisitas") {
            this.rotaAninhada = true;
            next();
        } else {
            this.rotaAninhada = false;
            this.carregarDados();
            next();
        }
    },
    components: {
        ContainerLoader,
        ButtonUpdateStatus,
    },
    data() {
        return {
            rotaIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("ROTAVISITA"),
            allrotas: [],
            service: new RotaVisitaService(this.$http, this.$router),
            situacoes: [
                { id: 2, label: "todos" },
                { id: 1, label: "ativos" },
                { id: 0, label: "inativos" },
            ],
            situacao: { id: 2, label: "todos" },
            fields: [
                {
                    key: "descricao",
                    label: "descricao",
                    width: null,
                    sortable: true,
                },
                {
                    key: "usuario",
                    label: "colaborador",
                    width: 400,
                    sortable: true,
                },
                { key: "situacao", width: 80, label: "situacao" },
            ],
            isLoading: false,
            isEmpty: false,
            queryFilter: "",
            column: "descricao",
            order: "asc",
            permissao: {},

            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,
                currentPage: 1,
            },
            onSearch: null,
        };
    },
    created() {
        if (
            this.$route.name.includes("rotavisita") &&
            this.$route.name != "ven-rotavisitas"
        ) {
            this.rotaAninhada = true;
        } else {
            this.rotaAninhada = false;
        }

        const outterContext = this;

        this.onSearch = this.debounce(function (value) {
            outterContext.queryFilter = outterContext.removeAcentos(value);
            outterContext.carregarDados();
        }, 500);

        this.debouncedOnSearch = this.debounce(this.onSearch, 500);
        this.pagination.perPage =
            this.pagination.perPageOptions[this.pagination.optionStarted];
        this.permissao = this.hasPermissionAccess(
            "vendas",
            "rota",
            "ven-rotavisitas"
        );
        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "routes" },
            });
        }
        this.carregarDados();
    },
    methods: {
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarDados(value.currentPage);
        },
        updateSituacao(t) {
            if (t) {
                this.situacao = t;
            } else {
                this.situacao = this.situacoes[0];
            }
            this.carregarDados();
        },
        carregarDados(currentPage = 1) {
            if (currentPage == 1 && this.pagination.currentPage != 1)
                this.pagination.resetPagination = true;
            this.isLoading = true;
            this.service
                .findAll(
                    currentPage - 1,
                    this.pagination.perPage,
                    this.situacao.id,
                    this.order,
                    this.column,
                    this.queryFilter
                )
                .then((r) => {
                    this.allrotas = r.content;
                    this.pagination.totalRows = r.totalElements;
                    this.isEmpty = this.allrotas.length <= 0;
                })
                .catch((e) => {
                    console.error("Erro ao carregar rotas.", e);
                    this.$root.showMessage("error", "msg-erro-dados-geral");
                    this.isEmpty = true;
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.pagination.resetPagination = false;
                });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarDados();
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
    min-height: calc(100% - 50px);
    position: relative;
}

.page {
    position: relative;
    padding-left: 0;
    .situacao-select div,
    .produtivo-select div {
        height: 40px;
    }
}
</style>
